// extracted by mini-css-extract-plugin
module.exports = {"center":"center__center___3N2g_"};